import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box } from '../../layouts';

export function BoxLayer({ className, children, ...props }) {
    return (
        <Box className={`odf-box odf-box-layer ${className}`} {...props}>
            {children}
        </Box>
    );
}
BoxLayer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node),
    ]),
};
BoxLayer.defaultProps = {
    className: '',
    children: null,
};

export function BoxPrimary(props) {
    return (
        <Box {...props} className="odf-box odf-box-primary">
            {props.children}
        </Box>
    );
}
BoxPrimary.propTypes = {
    children: PropTypes.array,
};
BoxPrimary.defaultProps = {
    children: null,
};

export function BoxContent(props) {
    return <Box className="odf-box-content">{props.children}</Box>;
}
BoxContent.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node),
    ]),
};
BoxContent.defaultProps = {
    children: null,
};

export function BoxFooter(props) {
    return <Box className="odf-box-footer">{props.children}</Box>;
}
BoxFooter.propTypes = {
    children: PropTypes.object,
};
BoxFooter.defaultProps = {
    children: null,
};

export const BoxOpacity = ({ className, children, ...props }) => (
    <Box
        className={classNames('odf-box', 'odf-box-opacity', className)}
        {...props}
    >
        {children}
    </Box>
);

BoxOpacity.propTypes = {
    children: PropTypes.object,
    className: PropTypes.string,
};
BoxOpacity.defaultProps = {
    children: null,
    className: null,
};
